import { Component, Vue } from 'vue-property-decorator';
import { HomeRow, } from "@/view-models";
import { namespace } from "vuex-class";
import { _homeService } from "@/services";
const user = namespace("user");

@Component
export default class SetAsFavoriteMixin extends Vue {

    @user.Getter
    isLoggedIn?: boolean;

    @user.State
    id!: string

    async setAsFavorite(value: HomeRow): Promise<void>{

        if(!this.isLoggedIn){
            this.$root.$emit("onNotLogged", "favorite");
            return;
        }

        const actionRequest = value.isFavorite ? _homeService.removeFavorite : _homeService.saveFavorite;

        actionRequest(value.itemAttachmentId, this.id).then(() => {
            value.isFavorite = !value.isFavorite;
        })

    }
}